export default "/images/b453542c6dd26083be2ed784c61ac590.avif";